export default {
  common: {
    payoutIfCorrect: 'Payout if correct',
    sendingOrder: 'Sending order...',
  },
  browse: {
    emptyState: {
      title: 'No active markets',
      description:
        "Looks like there aren't any active markets at the moment. Head back to browse and discover other markets you can trade.",
    },
    moreMarkets: 'More markets',
    sides: {
      yes: 'Yes',
      no: 'No',
    },
    dates: {
      today: 'Today',
      tomorrow: 'Tomorrow',
    },
  },
  futureDetail: {
    backToFutures: 'Back to futures',
    emptyState: 'No markets available',
  },
  homeWidget: {
    title: 'Predict upcoming games',
    allPredictions: 'All predictions',
  },
  card: {
    live: 'Live',
    winBy: 'WIN BY',
    total: 'TOTAL',
    winner: 'WINNER',
    gameDetails: 'More Markets',
  },
  detail: {
    tabs: {
      markets: 'Game lines',
      matchup: 'Match Stats',
      loadingLabel: 'Loading tabs',
    },
    winner: 'Winner',
    totals: 'Totals',
    matchup: 'Matchup',
    injuries: 'Injuries',
    matchupUnavailable: 'Matchup data is not available for this game',
    stats: {
      pointsPerGame: 'Points per game',
      pointsAgainst: 'Points against',
    },
    share: {
      matchTitle: '{{awayTeam}} vs {{homeTeam}}',
      fallbackTitle: 'Splash Predict',
      copySuccess: 'Game URL Copied!',
      copyError: 'Could not copy URL: {{url}}.',
      shareError: 'Could not share this game.',
    },
  },
  myPositions: {
    title: 'My Positions',
    tabs: {
      active: 'Active',
      final: 'Final',
    },
    downloadCsv: 'Download CSV',
    table: {
      market: 'Market',
      cost: 'Cost',
      price: 'Price',
      currentValue: 'Current Value',
      soldFor: 'Paid out',
      emptyState: 'No positions found',
    },
    card: {
      orders: '{{count}} purchases',
      cost: 'Cost',
      price: 'Price',
      currentValue: 'Current Value',
      paidOut: 'Paid out',
    },
    error: 'Error loading positions: {{message}}',
  },
  positionDetail: {
    activePosition: 'Active position',
    closedPosition: 'Closed position',
    boughtAt: 'Bought at',
    currentlyAt: 'Currently at',
    boughtFor: 'Bought for',
    paidOut: 'Paid out',
    cost: 'Cost',
    gainLoss: 'Gain/Loss',
    shares: 'shares',
    value: 'value',
    transactions: 'transactions',
    avgPrice: 'Avg. Price',
    purchases: '{{count}} purchases',
    buy: 'BUY',
    sell: 'SELL',
    buyMore: 'Buy more',
    sellAll: 'Sell all',
    sellingFor: 'Selling for',
    sellingForTooltip: 'Fees {{fee}}',
    sellingForTooltipLabel: 'About the sale fees',
    priceChange: 'Price change',
    notFound: 'Position not found',
    marketFallback: 'Market',
  },
  portfolio: {
    title: 'Portfolio',
  },
  reviewOrder: {
    title: 'Review Order',
    goBack: 'Go back',
    youreBuying: "You're buying",
    price: 'Price',
    submitting: 'Submitting...',
    tooltips: {
      youreBuying: 'Your cost was reduced to give you an even dollar payout. Includes fee.',
      youreBuyingWithFee:
        'Your cost was reduced to give you an even dollar payout. Includes a fee of {{fee}}.',
      youreBuyingLabel: 'About your purchase cost',
      payout: 'This market closes when the event ends. Projected payout 2 hours after closing.',
      payoutLabel: 'About your payout',
    },
    submitFor: 'Submit for {{amount}}',
    loginToSubmit: 'Log in to submit',
  },
  selection: {
    lineUnits: {
      points: 'points',
      goals: 'goals',
      runs: 'runs',
    },
    spread: '{{team}} {{line}}',
    total: 'Total {{line}}',
    totalMatchup: '{{away}} @ {{home}} • {{line}}',
    moneyline: '{{team}} to win',
    over: 'Over',
    under: 'Under',
  },
  panel: {
    buy: 'Buy',
    close: 'Close',
    goBack: 'Go back',
    expandPanel: 'Expand panel',
    amount: 'Amount',
    balance: 'Cash Balance: {{balance}}',
    marketVolume: 'Market volume:',
    today: 'Today',
    toWinLabel: '{{team}} TO WIN',
    moneylineTitle: '{{team}} to Win',
    avgPrice: 'Avg. Price',
    reviewAndBuy: 'Review & Buy',
    signUpOrLogin: 'Sign up or login to enter',
    marketClosed: 'Market Closed',
    locationRestricted: 'Location Restricted',
    marketUnavailable: 'Market Unavailable',
    loadingPrice: 'Loading price',
    deposit: 'Deposit',
    verifyMyAccount: 'Verify my account',
    completeVerification: 'Complete verification',
    uploadDocuments: 'Upload documents',
    contactSupport: 'Contact support',
    verifying: 'Verifying...',
    termsText: 'By trading, you agree to the Splash Market <link>Terms of Use</link>.',
    contractDisclaimer:
      'CFTC-regulated event contract · Listed on Polymarket US · Price is market-generated, not fixed odds',
  },
  rules: {
    marketRules: 'Market rules',
    gameWinner: 'Game winner',
    winByAndTotal: 'Win by and Total',
    winBy: 'Win by',
    total: 'Total',
    summary: 'Rules summary',
    tabs: {
      general: 'General',
      winBy: 'Win by',
      total: 'Total',
    },
    teams: 'Teams',
    viewFullRules: 'View full rules',
    noRules: 'Rules for this market are not available yet.',
  },
  orderSuccess: {
    price: 'Price',
    cost: 'Cost',
    paidOut: 'Paid out',
    sold: 'Sold',
    orderSuccessful: 'Order successful',
    share: 'Share',
  },
  footer: {
    rulesText: 'Review <link>Market Rules</link> before confirming.',
    termsText: 'All trading is subject to Splash Market <link>Terms of Use</link>.',
    browseTermsText: 'By trading, you agree to Splash Market <link>Terms of Use</link>.',
    disclaimer: {
      contracts:
        'Event contracts available on Splash Market, LLC are listed for trading on Polymarket US, a designated contract market regulated by the U.S. Commodity Futures Trading Commission. These are federally regulated derivative contracts. They are not sports bets, wagers, or bookmaking products, and Splash Market, LLC is not a sportsbook.',
      broker:
        'Splash Market, LLC is an introducing broker registered with the CFTC and a member of the National Futures Association (NFA ID 572313). It does not accept or hold customer funds and is not the counterparty to any transaction.',
      pricing:
        'Prices displayed are generated by the orders of market participants trading on Polymarket US. They are not odds offered by Splash Market, LLC or by Polymarket US, and neither party takes a position against you. Trading event contracts involves substantial risk of loss, including loss of the entire amount paid for a contract.',
    },
  },
  disclaimer: {
    text: 'Trading on Splash Market involves risk and may not be appropriate for all users. Splash Market is subject to U.S. regulatory oversight by the CFTC and NFA.',
    dismiss: 'Got it',
  },
  errors: {
    oppositeSidePosition:
      'You already own the other side of this market. Please sell your open position for this market first.',
    positionCheckFailed: 'Something went wrong. Please try again.',
    insufficientFunds: "Insufficient funds. To place this trade, you'll need to deposit more cash.",
    marketUnavailable: "This market isn't available right now.",
    maxBetExceeded: "Currently, this market's max purchase amount is {{amount}}",
    locationRestricted:
      'Your current location prevents you from using prediction markets. Please make sure you are in a permitted location, then try again.',
    priceChanged: 'Cost has changed to reflect the current market prices.',
    sendingOrder: 'Sending order...',
    submissionFailed: 'Failed to submit order',
    connectionTimeout: 'Connection timeout',
    noConnection: 'No internet connection, please try again later.',
    generic: 'Something went wrong, please try again later.',
    invalidPrice: 'Price must be greater than $0',
    invalidQuantity: 'Orders must be for at least {{quantity}} contract.',
    positionBelowMinSell:
      'This position is under {{quantity}} contract, so it cannot be sold. It will pay out when the market settles.',
  },
  kyc: {
    layout: {
      title: 'Markets verification',
      back: 'Go back',
      close: 'Close verification',
    },
    banner: {
      account: {
        verify: {
          title: 'Verify your account',
          subtitle: 'We need to verify your identity first.',
        },
        pending: {
          title: 'Verifying your account...',
          subtitle: 'Almost there. We’re just finalizing your details.',
        },
        failedTitle: 'Verification failed',
        refer: 'Please upload documents to proceed.',
        resubmit: 'Please resubmit your details again.',
        other: 'Contact support and we’ll help you.',
      },
      verify: {
        title: 'Confirm eligibility for trading',
        subtitle: 'We need to confirm a few more details.',
      },
      documents: {
        title: 'Verify your identity',
        subtitle: 'Please upload documents to proceed.',
      },
      documentsProcessing: {
        title: 'Verifying documents',
        subtitle: 'You’ll receive an update soon.',
      },
      pending: {
        title: 'Verifying your account...',
        subtitle: 'Usually takes just a few minutes.',
      },
      approved: {
        title: 'Verification completed',
        subtitle: 'You are ready to start using Markets',
      },
      denied: {
        title: 'Verification failed',
        subtitle: 'Contact support',
        supportMessage: "I'm having trouble verifying my account for Markets.",
        supportEmailSubject: 'Markets verification failed',
        supportEmailBody: 'Hello, Splash Support - {{message}}',
      },
      close: 'Close',
    },
    intro: {
      title: 'Get started with Markets',
      subtitle: 'To start trading on Markets, we need to confirm a few more details.',
      items: {
        ssn: {
          title: 'SSN',
          subtitle: 'Used to verify your identity.',
        },
        financialProfile: {
          title: 'Financial profile',
          subtitle: 'A few quick questions about your income and trading background.',
        },
      },
      cta: 'Let’s go',
    },
    identity: {
      title: 'Confirm your identity',
      subtitle: 'Provide your full SSN to complete verification.',
      ssnLabel: 'Your SSN',
      ssnPlaceholder: 'SSN',
      ssnNote: 'Used only for identity verification.',
      cta: 'Continue',
    },
    financialProfile: {
      title: 'Financial profile',
      subtitle: 'A few quick questions about your income and trading background.',
      incomeLabel: 'What is your annual income?',
      incomePlaceholder: 'Select your annual income',
      income: {
        under_50k: 'Under $50K',
        '50k_100k': '$50K - $100K',
        '100k_250k': '$100K - $250K',
        '250k_plus': 'Over $250K',
      },
      netWorthLabel: 'What is your net worth? (excluding home)',
      netWorthPlaceholder: 'Select your net worth',
      netWorth: {
        under_100k: 'Under $100K',
        '100k_500k': '$100K - $500K',
        '500k_1M': '$500K - $1M',
        '1M_plus': 'Over $1M',
      },
      cta: 'Continue',
    },
    tradingExperience: {
      title: 'Trading Experience & Acknowledgment',
      subtitle: 'Tell us about your experience trading swaps, futures, or event contracts.',
      levels: {
        none: {
          label: 'None',
          note: 'I’ve never traded before',
        },
        some: {
          label: 'Some',
          note: 'I’ve traded occasionally',
        },
        advanced: {
          label: 'Advanced',
          note: 'I trade regularly',
        },
      },
      error: 'You need to select one option before submitting.',
      acknowledgement:
        'You acknowledge and agree that you have read and understand the <terms>Splash Market Terms of Use</terms>, <risk>Customer Risk Disclosures</risk> and <privacy>Splash Market Privacy Policy</privacy>. These disclosures explain important legal, regulatory, and financial risks associated with trading sports event contracts introduced by Splash Market. These contracts are offered by Polymarket US and subject to oversight by the <cftc>Commodity Futures Trading Commission</cftc>.',
      acknowledgementLabel: 'Acknowledge the Splash Market terms and disclosures',
      cta: 'Continue',
    },
    acknowledgement: {
      title: 'Acknowledgement and Acceptance of Terms',
      subtitle: 'Almost ready to trade!',
      checkbox:
        'You acknowledge that you have reviewed and agree to the Polymarket US Participant agreement, Clearing Rulebook, Exchange Rulebook, and Risk Disclosure.',
      checkboxLabel: 'Acknowledge and accept the Polymarket US terms',
      documents: {
        participantAgreement: 'Polymarket US Participant Agreement',
        clearingRulebook: 'Polymarket US Clearing Rulebook',
        exchangeRulebook: 'Polymarket US Exchange Rulebook',
        riskDisclosure: 'Polymarket US Risk Disclosure',
      },
      riskNote: 'Trading involves substantial risk of loss and may not be suitable for everyone.',
      cta: 'Submit',
      submissionFailed: 'We couldn’t submit your verification. Please try again.',
    },
    documents: {
      title: 'Additional Verification needed',
      subtitle:
        'We need to verify your identity with a photo ID. Please upload documents to proceed.',
      cta: 'Upload documents',
      secondaryCta: 'Contact support',
      failed: 'We couldn’t verify your documents. Please try again.',
      supportMessage: 'I need help uploading my documents for Markets verification.',
    },
    documentsVerifying: {
      title: 'Verifying documents',
      subtitle:
        'Your documents are in the process of being verified. This typically only takes a few minutes. You’ll receive an update soon.',
      cta: 'Dismiss',
      secondaryCta: 'Contact support',
      supportMessage: 'I need help with the document verification for my Markets account.',
    },
    review: {
      title: 'Your Markets verification is being reviewed',
      subtitle: 'We’re checking your details. You’ll be ready to trade in just a few minutes.',
      cta: 'Got it',
    },
    success: {
      title: 'You are all set!',
      subtitle: 'You are ready to start using Markets',
      cta: 'Done',
    },
    error: {
      title: 'We couldn’t verify your identity',
      subtitle:
        'We’re unable to verify your information right now. Contact support and we’ll help you get set up.',
      cta: 'Contact support',
      secondaryCta: 'Close',
      supportMessage: 'I need help verifying my account for Markets.',
    },
  },

  playerProps: {
    yes: 'Yes',
    no: 'No',
    seeAll: 'See all ({{count}})',
    showLess: 'Show less',
    categoriesLabel: 'Player prop categories',
    teamToggleLabel: 'Team',
    changeLine: 'Change line for {{player}}',
    lineOptions: 'Line options for {{player}}',
    previousLine: 'Previous line for {{player}}',
    nextLine: 'Next line for {{player}}',
    loadingLabel: 'Loading player props',
    loadMore: 'Load more',
    back: 'Back',
    live: 'LIVE',
    empty: {
      notPosted: {
        title: 'Player props aren’t posted yet',
        description: 'Props usually open 24–48 hours before kickoff.',
        action: 'See game lines',
      },
      settled: {
        title: 'Player props have settled',
        description:
          'This game is final, so trading is closed. Upcoming games still have open markets.',
        action: 'Browse other games',
      },
    },
    error: {
      title: 'Couldn’t load markets',
      description: 'Check your connection and try again.',
      action: 'Try again',
    },
  },
  settings: {
    title: 'Pricing & Order Settings',
    priceFormat: {
      title: 'Pricing format',
      summary: '{{format}} ({{sample}})',
    },
    priceTolerance: {
      title: 'Price tolerance',
      description:
        'Price tolerance is applied per contract on single buys and sells, allowing execution within your set range and reducing failed orders, though prices may be less favorable.',
      amountLabel: 'Tolerance amount',
      valueCents: '{{cents}}¢',
      saveError: 'Couldn’t update your price tolerance. Please try again.',
    },
  },
};
